import React from "react";
import { appColors, appRadius, appType } from "../../utils/appTheme";

/**
 * Control segmentado (pill). options: [{ value, label }].
 */
const SegmentedControl = ({ options = [], value, onChange, style }) => (
  <div
    style={{
      display: "flex",
      gap: 3,
      padding: 3,
      borderRadius: appRadius.pill,
      border: `1px solid ${appColors.line}`,
      background: appColors.surface,
      ...style,
    }}
  >
    {options.map((opt) => {
      const active = opt.value === value;
      return (
        <button
          key={opt.value}
          type="button"
          onClick={() => onChange && onChange(opt.value)}
          style={{
            flex: 1,
            border: "none",
            borderRadius: appRadius.pill,
            padding: "9px 10px",
            cursor: "pointer",
            fontFamily: appType.fontFamily,
            fontSize: 13.5,
            fontWeight: 400,
            background: active ? appColors.blue : "transparent",
            color: active ? appColors.onBlue : appColors.ink2,
            transition: "background .15s ease, color .15s ease",
          }}
        >
          {opt.label}
        </button>
      );
    })}
  </div>
);

export default SegmentedControl;
